/* tslint:disable */
/* eslint-disable */
export enum GenderEnum {
  Unspecified = 'Unspecified',
  Male = 'Male',
  Female = 'Female',
  None = 'None'
}
